import type { TenantMode } from "services/tenant/tenant-mode.service"

export const _currentTenant = process.env.REACT_APP_TENANT?.toLocaleLowerCase()

/**
 * The tenant's migration mode, resolved from `GET /admin/tenant-mode` by PropsProvider before the
 * app renders (and again after every login). The backend is the single owner of
 * `MICROSERVICE_TENANTS` and the bonus / $TOKEN flags; the admin no longer mirrors them in a
 * build-time env, which drifted on every tenant cutover (INCIDENT-097).
 *
 * `null` = not resolved (before login, or the fetch failed). Every predicate below answers `false`
 * then, i.e. the monolith view — MS-only tooling must never appear on a tenant whose mode is unknown.
 */
let tenantMode: TenantMode | null = null

export const setTenantMode = (mode: TenantMode | null): void => {
  tenantMode = mode
}

export const getTenantMode = (): TenantMode | null => tenantMode

/** True when financial-service owns the wallet: native amounts, FS-authoritative balances, NUX bets. */
export const isMicroserviceTenant = (): boolean => tenantMode?.money_authority === "fs"

/** True when bonus-service owns the bonus catalog (Bonus V2 pages instead of the legacy tables). */
export const isBonusV2Tenant = (): boolean => tenantMode?.bonus_catalog === "v2"

/** True when the $TOKEN module is active for the tenant. */
export const isTokenTenant = (): boolean => tenantMode?.token_enabled === true
